import { Link } from 'react-router-dom';
import { SEO_CLUSTERS } from '@/lib/homeData';

export default function ResourcesLinksSection() {
  return (
    <section className="bg-[#f8f5ef] px-6 py-12">
      <div className="container mx-auto max-w-6xl rounded-2xl border border-slate-200 bg-slate-50 p-6">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-500">Resources</p>
        <div className="mt-3 flex flex-wrap gap-2">
          {SEO_CLUSTERS.flatMap((cluster) => cluster.links).map((item) => (
            <Link
              key={item.href + item.label}
              to={item.href}
              className="rounded-full border border-slate-300 bg-white px-3 py-1 text-xs font-medium text-slate-700 transition hover:border-slate-500 hover:text-slate-900"
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
